export const AudioQcFieldName = 'audioQcFieldComponent';
